import React from 'react';
import { Box } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('CapitalizeInfoRow', (theme) => ({
  bottomBorder: {
    borderBottom: '1px solid #CCC',
    paddingTop: theme.spacing(2),
  },
}));

const CapitalizeInfoRow = ({ attrName }) => {
  const classes = useStyles();

  return (
    <Box direction={'column'}>
      <MetaControlField attr={attrName} />
      <div className={classes.bottomBorder} />
    </Box>
  );
};

CapitalizeInfoRow.defaultProps = {
};

CapitalizeInfoRow.propTypes = {
  attrName: PropTypes.string.isRequired,
};

export default CapitalizeInfoRow;
